(function () {
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.js-caraxy-free-gift-btn');
    if (!button) return;

    const giftVariantId = Number(button.dataset.giftVariantId);
    const discountUrl = button.dataset.discountUrl || '/discount/GROW-YOUR-LOVE?redirect=/checkout';

    if (!giftVariantId) {
      console.error('Missing free gift variant ID.');
      return;
    }

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding your gift...';

    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      const cart = await cartResponse.json();

      const giftAlreadyInCart = cart.items.some(function (item) {
        return Number(item.variant_id) === giftVariantId;
      });

      if (!giftAlreadyInCart) {
        const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: giftVariantId,
                quantity: 1,
                properties: {
                  _promotion: 'GROW-YOUR-LOVE'
                }
              }
            ]
          })
        });

        if (!addResponse.ok) {
          const errorData = await addResponse.json().catch(function () {
            return {};
          });

          throw new Error(errorData.description || 'Unable to add free gift.');
        }
      }

      window.location.href = discountUrl;
    } catch (error) {
      console.error('Free gift error:', error);

      button.disabled = false;
      button.textContent = originalText;

      alert('Sorry, we could not add your free necklace. Please try again.');
    }
  });
})();